import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import {Alert, ConfirmModal, StrokeIcon} from "./ui";

const UndoCancelFileButton = ({fileId, status, price_status}) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleCancel = async () => {
        try {
            setLoading(true);
            await axiosInstance.put(`/files/${fileId}/cancel/undo`);
            setLoading(false);
            navigate(`/admin/view-file/${fileId}`);
        } catch (error) {
            setLoading(false);
            if (error.response.status === 400) {
                setErrorMessage(error.response.data.message);
                return;
            }
            setErrorMessage("Something went wrong");
        } finally {
            setShowModal(false);
        }
    };

    return (
        <div className="space-y-2">
            {errorMessage && <Alert tone="error">{errorMessage}</Alert>}

            {price_status && price_status === "UNPAID" && (
                <button
                    onClick={() => setShowModal(true)}
                    disabled={loading}
                    className="flex w-full items-center gap-2 rounded-[10px] px-3 py-2 text-left text-sm font-medium text-gray-700 transition hover:bg-gray-100 disabled:opacity-50 dark:text-slate-200 dark:hover:bg-[#262628]"
                >
                    <StrokeIcon className="h-4 w-4">
                        <path d="M3 12a9 9 0 1 0 3-6.7L3 8"/>
                        <path d="M3 3v5h5"/>
                    </StrokeIcon>
                    Undo cancel
                </button>
            )}

            {showModal && (
                <ConfirmModal
                    title="Undo cancel?"
                    message="Are you sure you want to undo the cancellation of this file?"
                    confirmLabel="Yes, undo it"
                    tone="accent"
                    busy={loading}
                    onConfirm={handleCancel}
                    onCancel={() => setShowModal(false)}
                />
            )}
        </div>
    );
};

export default UndoCancelFileButton;